import React, { Component, useEffect, useState } from 'react';
import endpoint_info from '../../data/2023-05/endpoints_info__FG_pheno-r11_geno-r10__2023-05-17.json';
import * as d3 from "d3";

function BlockList (props) {

    const data = props.data
    const search = props.search
    const setSearch = props.setSearch
    const endpoints = props.endpoints
    const setEndpoints = props.setEndpoints
    const contentHeight = props.contentHeight
    const highlightQuery = props.highlightQuery

    function getFilteredData (search) {
        if (search === undefined) return data
        else {
            var newFilteredData = []
            data.forEach(block => {
                function checkBlockCodes (block, search) {
                    const searchCode = search.split(' ')[0].toUpperCase()
                    const code = block.code

                    if (code.includes('-')) {
                        const letter1 = code.split('-')[0][0]
                        const letter2 = code.split('-')[1][0]
                        const start1 = +code.replaceAll(letter1, '').split('-')[0]
                        const end2 = +code.replaceAll(letter2, '').split('-')[1]

                        function getSingleBlockCode(letter, number) {
                            const singleCode = number > 9 ? letter+number : letter+'0'+number
                            return singleCode
                        }

                        if (letter1 === letter2) {
                            const range = [...Array(end2 - start1 + 1).keys()].map(x => x+start1).map(x => getSingleBlockCode(letter1, x));
                            return range.includes(searchCode)
                        } else {
                            const alphabet = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
                            const start = alphabet.indexOf(letter1);
                            const end = alphabet.indexOf(letter2);
                            const letters = [...Array(end - start + 1).keys()].map(x => alphabet[x+start]);
                            var range = [];
                            letters.forEach((letter,i) => {
                                var currentRange = []
                                if (i === 0) currentRange = [...Array(99 - start1 + 1).keys()].map(x => x+start1).map(x => getSingleBlockCode(letter, x))
                                else if (i === letters.length-1) currentRange = [...Array(end2 + 1).keys()].map(x => getSingleBlockCode(letter, x))
                                else currentRange = [...Array(100).keys()].map(x => getSingleBlockCode(letter, x))
                                currentRange.forEach(el => range.push(el))
                            })
                            return range.includes(searchCode)
                        }
                    }
                    else return code.includes(searchCode)
                }
                
                function getRelevantEndpoints (block, search) {
                    var relevantEndpoints = []
                    block.endpoints.forEach(el => {
                        const endpoint = endpoint_info.filter(info => info.code === el)[0]
                        if (endpoint && (endpoint.code.toLowerCase().includes(search.replaceAll(' ', '_')) || endpoint.longname.toLowerCase().includes(search))) relevantEndpoints.push(el)
                    })
                    return relevantEndpoints
                }

                if (block.name.toLowerCase().includes(search)) newFilteredData.push(block)
                else if (getRelevantEndpoints(block, search).length > 0) newFilteredData.push(block)
                else if (checkBlockCodes(block, search)) newFilteredData.push(block)
            })
            return newFilteredData
        }
    }

    function drawBlocks (selection) {
        const block = selection.selectAll('.block').data(d => d.content).enter().append('div')
            .attr('class', 'block')
            .classed('selectedBlock', d => d.name === endpoints.name)
            .on("click", (e, d) => setEndpoints(d))
        block.append("div").attr('class', 'block_name').html(d => highlightQuery(d.name, search))
        block.append("div").attr('class', 'block_code').html(d => d.code)
    }

    useEffect(()=> {
        // document.getElementById('block_list').scrollTop = 0
        d3.select('#block_list').style('height', search === undefined ? contentHeight-43+'px' : contentHeight-178+'px')

        const filteredData = getFilteredData(search)
        const groups = d3.group(filteredData.map(el => {return {...el, letter: el.code[0]}}), el => el.letter)
        const letters = Array.from(groups, ([key, value]) => {return {letter: key, content: value}})

        d3.select('#block_list').selectAll('.block_main').data(letters).join(
          function(enter){
            const letter = enter.append('div')
                .attr('id', d => d.letter +'block')
                .attr('class', 'block_main')
            
            letter.append('div')
              .attr('class', 'block_letter')
              .html(d => d.letter)
            
            drawBlocks(letter)
          },
          function(update){
            update.select('.block_letter').html(d => d.letter)
            update.selectAll('.block').remove()

            drawBlocks(update)
          }
        )
    })

    return (
        <div id='blocks'>
            <div id='block_title'>
                <h5 style={{margin: '10px 0 0 0'}}>ICD blocks</h5>
            </div>
            {search !== undefined && (
                <div id='block_search'>
                    <button id='block_query' onClick={()=>setSearch(undefined)}>{search} ×</button>
                    <p>ICD blocks containing the search query and those with endpoints that have the search query.</p>
                </div>
            )}
            <div id='block_list'></div>
        </div>
    )
}

export default BlockList;